import {CustomFileType, UploadFileResponseType} from '../../../../../../service/file-upload/file-upload-type';
import {
    YandexStoryFormFieldsEnum,
    YandexStoryFormType,
} from '../../../../../../service/yandex-stories/yandex-stories-type';
import {FormInstance} from '../../../../../../typings/antd';
import {YANDEX_STORY__MAX_SLIDES} from '../../../yandex-story-form-helper';

export type UploadedSlideFilesMapType = Record<string, CustomFileType & UploadFileResponseType>;

// The single write path of both slide uploaders — the empty-state panel and the "+" tile of the rail.
// Appending instead of replacing the field is what lets them coexist: whichever batch lands second
// still sees the slides of the first one.
//
// The count is read here rather than passed in from a render, so the numbering and the limit stay
// right even when both uploaders have a batch in flight.
//
// Slides keep the order the browser reported the files in: rc-upload awaits every `beforeUpload` and
// only then posts the batch in its original order (`AjaxUploader.uploadFiles`), and the uids it
// generates are non-numeric strings, so insertion order survives `Object.entries`.
export function appendYandexStorySlides(
    formInstance: FormInstance<YandexStoryFormType>,
    filesMap: UploadedSlideFilesMapType
): void {
    const currentSlidesCount = Object.keys(formInstance.getFieldValue([YandexStoryFormFieldsEnum.Slides]) ?? {}).length;

    Object.entries(filesMap)
        .slice(0, YANDEX_STORY__MAX_SLIDES - currentSlidesCount)
        .forEach(([key, fileItem], index) => {
            formInstance.setFieldValue([YandexStoryFormFieldsEnum.Slides, key], {
                ...fileItem,
                buttonConfig: null,
                order: currentSlidesCount + index + 1,
                name: '',
            });
        });
}
